import { CardProps } from '../Card';

export type BannerColorScheme =
  | 'lavender-gradient'
  | 'lavender-bg'
  | 'iridescent'
  | 'transparent';

export const getBannerColorScheme = (
  colorScheme: BannerColorScheme
): {
  bannerBg: `bg-${string} dark:bg-${string}`;
  text: `text-${string} dark:text-${string}`;
  textSecondary: `text-${string} dark:text-${string}`;
  ctaText?: `text-${string} dark:text-${string}`;
  ctaBg: `bg-${string} dark:bg-${string}`;
  ctaHoverBg: string;
  countdownBg: `bg-${string} dark:bg-${string}`;
  countdownText: `text-${string} dark:text-${string}`;
  borderColor?: CardProps['color'];
} => {
  switch (colorScheme) {
    case 'transparent':
    default:
      return {
        bannerBg: 'bg-transparent dark:bg-transparent',
        text: 'text-base-black dark:text-base-dark-white',
        textSecondary: 'text-gray-500 dark:text-base-dark-white',
        ctaBg:
          'bg-white border-base-black dark:bg-dark-brand-500 dark:border-none',
        ctaHoverBg: '',
        countdownBg: 'bg-brand-800 dark:bg-brand-800',
        countdownText: 'text-base-white dark:text-base-dark-white',
        borderColor: 'gradient',
      };
    case 'iridescent':
      return {
        bannerBg:
          'bg-gradient-main-semi-transparent dark:bg-gradient-main-semi-transparent',
        text: 'text-base-black dark:text-base-dark-black',
        textSecondary: 'text-base-black dark:text-base-dark-black',
        ctaText: 'text-base-white dark:text-base-dark-white',
        ctaBg: 'bg-base-black dark:bg-base-dark-black',
        ctaHoverBg:
          'hover:bg-gray-800 hover:border-none dark:hover:bg-gray-200 dark:hover:border-none',
        countdownBg: 'bg-secondary-100 dark:bg-secondary-100',
        countdownText: 'text-base-white dark:text-base-dark-black',
      };
    case 'lavender-bg':
      return {
        bannerBg: 'bg-brand-50 dark:bg-brand-950',
        text: 'text-gray-950  dark:text-gray-900',
        textSecondary: 'text-gray-600 dark:text-gray-500',
        ctaText: 'text-base-white dark:text-base-dark-black',
        ctaBg: 'bg-base-black dark:bg-base-dark-white',
        ctaHoverBg:
          'hover:bg-gray-800 hover:border-none dark:hover:bg-gray-100 dark:hover:border-none',
        countdownBg: 'bg-secondary-100 dark:bg-secondary-100',
        countdownText: 'text-base-white dark:text-base-dark-black',
        borderColor: 'gradient',
      };
    case 'lavender-gradient':
      return {
        bannerBg: 'bg-gradient-secondary-1 dark:bg-gradient-secondary-1',
        text: 'text-base-white dark:text-base-dark-white',
        textSecondary: 'text-base-white dark:text-base-dark-white',
        ctaText: 'text-base-black dark:text-base-dark-black',
        ctaBg:
          'bg-base-white border-none dark:bg-base-dark-white dark:border-none',
        ctaHoverBg:
          'hover:bg-gray-100 hover:shadow-none dark:hover:bg-gray-800 hover:dark:shadow-none',
        countdownBg: 'bg-secondary-100 dark:bg-secondary-100',
        countdownText: 'text-base-white dark:text-base-dark-black',
      };
  }
};
